import { render, staticRenderFns } from "./ResponsiveImageVW.vue?vue&type=template&id=4f310bf0&"
import script from "./ResponsiveImageVW.vue?vue&type=script&lang=js&"
export * from "./ResponsiveImageVW.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports